import React from "react";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../../../Pages/CycleCountSetting/cycleCountSetting.css";

const CycleCustomModal = ({
  open,
  onClose = () => {},
  title = "",
  children,
  vMediaQuery,
  xMediaQuery,
  xVendor = "",
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 3,
          width: vMediaQuery
            ? "100%"
            : xMediaQuery
            ? "95%"
            : ["Item Master"].includes(title)
            ? "85%"
            : ["Report", "Item Selection"].includes(title)
            ? "90%"
            : [
                "Stock Setting Detail",
                "BoxPallet Receipt Detail",
                "BoxPallet Issue Detail",
                "CyclicCounting Detail",
              ].includes(title)
            ? "85%"
            : [
                "Filter Modal",
                "Approve Modal",
                "Stock Setup Change Approve CM",
                "Stock Setup Change Approve PM",
                "Stock Setup Change Approve ",
                "Vendor Discontinue Change Approve ",
                "Vendor Discontinue Change Approve CM",
                "Vendor Discontinue Change Approve PM",
                "Item Listing Approve ",
                "Item Listing Approve CM",
                "Item Listing Approve PM",
                "Item Moq Approve ",
                "Item Moq Approve CM",
                "Item Moq Approve PM",
                "RSP Change Approve ",
                "RSP Change Approve CM",
                "RSP Change Approve PM"
              ].includes(title)
            ? "95%"
            : ["Vendor Item Search -"].includes(title)
            ? "100%"
            : "70%",
          height:
            [
              "Stock Setting Detail",
              "Item Selection",
              "BoxPallet Receipt Detail",
              "BoxPallet Issue Detail",
              "Item Master",
              "Item Search",
              "Report",
              "Loading PalletId",
            ].includes(title) && vMediaQuery
              ? "85vh"
              : title === "CyclicCounting Detail" && vMediaQuery
              ? "90vh"
              : title === "CyclicCounting Detail"
              ? "80vh"
              : ["Item Master", "Stock Setting Detail"].includes(title)
              ? "90vh"
              : [
                  "Item Selection",
                  "BoxPallet Receipt Detail",
                  "BoxPallet Issue Detail",
                ].includes(title)
              ? "85vh"
              : [
                  "Filter Modal",
                  "Approve Modal",
                  "Stock Setup Change Approve CM",
                  "Stock Setup Change Approve PM",
                  "Stock Setup Change Approve ",
                  "Vendor Discontinue Change Approve ",
                  "Vendor Discontinue Change Approve CM",
                  "Vendor Discontinue Change Approve PM",
                  "Item Listing Approve ",
                  "Item Listing Approve CM",
                  "Item Listing Approve PM",
                  "Item Moq Approve ",
                  "Item Moq Approve CM",
                  "Item Moq Approve PM",
                  "RSP Change Approve ",
                  "RSP Change Approve CM",
                  "RSP Change Approve PM"
                ].includes(title) && vMediaQuery
              ? "100vh"
              : "90vh",
          // : title === "Filter Modal" || title === "Approve Modal"
          // ? "90vh"
          // : "100vh",
          display: "flex",
          overflowY: "auto",
          flexDirection: "column",
        }}
      >
        {/* Title and Close Icon */}
        <Box className="modalSS-head" sx={{ flexShrink: 0 }}>
          <Typography
            variant={vMediaQuery ? "subtitle1" : "h6"}
            sx={{ marginTop: vMediaQuery ? 0.5 : 0.4 }}
          >
            {title} {xVendor}
          </Typography>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Modal Content with Scroll */}
        <Box
          sx={{
            paddingX: ["Filter"].includes(title)
              ? "20px"
              : vMediaQuery
              ? "10px"
              : "24px",
            flexGrow: 1,
            // height: '85vh',
            paddingBottom: ["Filter"].includes(title) ? "20px" : "10px",
            overflowY: "auto",
          }}
          paddingTop={vMediaQuery || xMediaQuery ? "0px" : "8px"}
        >
          {children}
        </Box>
      </Box>
    </Modal>
  );
};

export default CycleCustomModal;
